import { render } from "./ContentTabComponent.vue?vue&type=template&id=eda2d79a&scoped=true"
import script from "./ContentTabComponent.vue?vue&type=script&lang=js"
export * from "./ContentTabComponent.vue?vue&type=script&lang=js"

import "./ContentTabComponent.vue?vue&type=style&index=0&id=eda2d79a&scoped=true&lang=css"

import exportComponent from "/builds/pazzei/pazzei-landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eda2d79a"]])

export default __exports__